module.exports = __webpack_public_path__ + "img/商品详情-3.d95b9845.png";